import { EasyfyEventData, IDataMapper, IEasyfyEvent } from "@shared/easyfy.events/easyfy.eventdata";
import { EventNames } from "@shared/easyfy.events/easyfy.eventhandler";

/* Exporter class */
export class Ga4DataMapper implements IDataMapper {

  MapEventData(event: IEasyfyEvent): any {
    var mappedEvent: any;

    switch (event.eventName.toLowerCase()) {
      case EventNames.ProductImpression: {
        mappedEvent = this.ViewItemListEvent(event);
        break;
      }
      case EventNames.ProductClick: {
        mappedEvent = this.SelectItemEvent(event);
        break;
      }
      case EventNames.ProductPageView: {
        mappedEvent = this.ViewItemEvent(event);
        break;
      }
      case EventNames.BannerImpression: {
        mappedEvent = this.ViewPromotionEvent(event);
        break;
      }
      case EventNames.BannerClick: {
        mappedEvent = this.SelectPromotionEvent(event);
        break;
      }
      case EventNames.AddToCart: {
        mappedEvent = this.AddToCartEvent(event);
        break;
      }
      case EventNames.RemoveFromCart: {
        mappedEvent = this.RemoveFromCartEvent(event);
        break;
      }
      case EventNames.StartedCheckout: {
        mappedEvent = this.StartedCheckoutEvent(event);
        break;
      }
      case EventNames.ContinueToPayment: {
        mappedEvent = this.ContinueToPaymentEvent(event);
        break;
      }
      case EventNames.CompletedCheckout: {
        mappedEvent = this.CompletedCheckoutEvent(event);
      }
    }

    return mappedEvent;
  }

  ViewItemListEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifiers) throw new Error('Product identifiers missing');
    if (!event.data.salesUnitCodes) throw new Error('Product sales unit codes missing');
    if (event.data.salesUnitCodes.length != event.data.productIdentifiers.length) throw new Error('Product sales unit codes and identifiers count missmatch');
    var priceIds: string[] = [];
    var siteInfo = EasyfyEventData.SiteInfo();
    var ga4items: any[] = [];

    for (var i = 0; i < event.data.productIdentifiers.length; i++) {
      priceIds.push(event.data.productIdentifiers[i] + "-" + event.data.salesUnitCodes[i]);
    }

    var eventProducts = EasyfyEventData.Products(event.data.productIdentifiers);
    var eventPrices = EasyfyEventData.ProductSalesUnitPrices(priceIds);

    for (var i = 0; i < eventProducts.length; i++) {
      var product = eventProducts[i];
      var salesUnitPrice = eventPrices[i];

      var index = eventProducts.indexOf(product);
      var productListIndex = EasyfyEventData.ProductIndexInList(event.data.listIds[index], product.Id) + 1;

      ga4items.push({
        discount: null,
        variant: null,
        coupon: null,
        price: salesUnitPrice.priceExVat,
        index: productListIndex,
        item_list_name: event.data.listIds[index],
        item_variant: null,
        item_id: product.Id,
        item_name: product.DisplayName,
        item_brand: product.Brand,
        item_category: product.Categories.length > 0 ? product.Categories[0] : null,
        item_category2: product.Categories.length > 1 ? product.Categories[1] : null,
        item_category3: product.Categories.length > 2 ? product.Categories[2] : null,
        item_category4: product.Categories.length > 3 ? product.Categories[3] : null,
        item_category5: product.Categories.length > 4 ? product.Categories[4] : null,
        quantity: 1
      });
    }

    var gaEvent = {
      event: "view_item_list",
      ecommerce: {
        currency: siteInfo.currencyCode,
        items: ga4items
      }
    };

    return gaEvent;
  }

  SelectItemEvent(event: IEasyfyEvent): any {

    if (!event.data.productIdentifier) throw new Error('Product identifier missing');

    var product = EasyfyEventData.Product(event.data.productIdentifier);
    var salesUnitPrice = EasyfyEventData.ProductSalesUnitPrice(event.data.productIdentifier + "-" + event.data.salesUnitCode);
    var productListIndex = EasyfyEventData.ProductIndexInList(event.data.listName, product.Id);
    var siteInfo = EasyfyEventData.SiteInfo();
    var ga4items: any[] = []; 

    ga4items.push({
      discount: null,
      variant: null,
      coupon: null,
      price: salesUnitPrice.priceExVat,
      index: productListIndex + 1,
      item_list_name: event.data.listName,
      item_variant: null,
      item_id: product.Id,
      item_name: product.DisplayName,
      item_brand: product.Brand,
      item_category: product.Categories.length > 0 ? product.Categories[0] : null,
      item_category2: product.Categories.length > 1 ? product.Categories[1] : null,
      item_category3: product.Categories.length > 2 ? product.Categories[2] : null,
      item_category4: product.Categories.length > 3 ? product.Categories[3] : null,
      item_category5: product.Categories.length > 4 ? product.Categories[4] : null,
      quantity: 1
    });

    var gaEvent = {
      event: "select_item",
      ecommerce: {
        currency: siteInfo.currencyCode,
        items: ga4items
      }
    };

    return gaEvent
  }

  ViewItemEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) throw new Error('Product identifier missing');

    var product = EasyfyEventData.Product(event.data.productIdentifier);
    var salesUnitPrice = EasyfyEventData.ProductSalesUnitPrice(event.data.productIdentifier + "-" + event.data.salesUnitCode);

    var siteInfo = EasyfyEventData.SiteInfo();
    var ga4items: any[] = []; 

    ga4items.push({
      discount: null,
      variant: null,
      coupon: null,
      price: salesUnitPrice.priceExVat,
      index: null,
      item_list_name: null,
      item_variant: null,
      item_id: product.Id,
      item_name: product.DisplayName,
      item_brand: product.Brand,
      item_category: product.Categories.length > 0 ? product.Categories[0] : null,
      item_category2: product.Categories.length > 1 ? product.Categories[1] : null,
      item_category3: product.Categories.length > 2 ? product.Categories[2] : null,
      item_category4: product.Categories.length > 3 ? product.Categories[3] : null,
      item_category5: product.Categories.length > 4 ? product.Categories[4] : null,
      quantity: 1
    });

    var gaEvent = {
      event: "view_item",
      ecommerce: {
        currency: siteInfo.currencyCode,
        value: salesUnitPrice.priceExVat,
        items: ga4items
      }
    };

    return gaEvent;
  }
  ViewPromotionEvent(event: IEasyfyEvent): any {
    if (!event.data.bannerIdentifier) throw new Error('Banner identifier missing');;

    var banner = EasyfyEventData.Banner(event.data.bannerIdentifier);
    var ga4items: any[] = []; 

    ga4items.push({
      promotion_id: banner.Id,
      promotion_name: banner.DisplayName,
      quantity: 1,
      cd_linkUrl: banner.LinkUrl,
      cd_pageUrl: banner.PageUrl,
      creative_name: null,
      creative_slot: null,
      discount: null,
      coupon: null,
      price: null,
      item_list_name: null,
      item_variant: null,
      item_id: null,
      item_name: null,
      item_brand: null,
      item_category: null,
      item_category2: null,
      item_category3: null,
      item_category4: null,
      item_category5: null
    });

    var gaEvent = {
      event: "view_promotion",
      ecommerce: {
        items: ga4items
      }
    };

    return gaEvent;
  }

  SelectPromotionEvent(event: IEasyfyEvent): any {
    if (!event.data.bannerIdentifier) throw new Error('Banner identifier missing');

    var banner = EasyfyEventData.Banner(event.data.bannerIdentifier);
    var ga4items: any[] = []; 

    ga4items.push({
      promotion_id: banner.Id,
      promotion_name: banner.DisplayName,
      quantity: 1,
      cd_linkUrl: banner.LinkUrl,
      cd_pageUrl: banner.PageUrl,
      creative_name: null,
      creative_slot: null,
      discount: null,
      coupon: null,
      price: null,
      item_list_name: null,
      item_variant: null,
      item_id: null,
      item_name: null,
      item_brand: null,
      item_category: null,
      item_category2: null,
      item_category3: null,
      item_category4: null,
      item_category5: null
    });

    var gaEvent = {
      event: "select_promotion",
      ecommerce: {
        items: ga4items
      }
    };

    return gaEvent;
  }

  AddToCartEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) throw new Error('Product identifier missing');

    var product = EasyfyEventData.Product(event.data.productIdentifier);
    var salesUnitPrice = EasyfyEventData.ProductSalesUnitPrice(event.data.productIdentifier + "-" + event.data.salesUnitCode);

    var siteInfo = EasyfyEventData.SiteInfo();
    var ga4items: any[] = []; 

    ga4items.push({
      discount: null,
      variant: null,
      coupon: null,
      price: salesUnitPrice.priceExVat,
      index: null,
      item_list_name: event.data.listName,
      item_variant: null,
      item_id: product.Id,
      item_name: product.DisplayName,
      item_brand: product.Brand,
      item_category: product.Categories.length > 0 ? product.Categories[0] : null,
      item_category2: product.Categories.length > 1 ? product.Categories[1] : null,
      item_category3: product.Categories.length > 2 ? product.Categories[2] : null,
      item_category4: product.Categories.length > 3 ? product.Categories[3] : null,
      item_category5: product.Categories.length > 4 ? product.Categories[4] : null,
      quantity: event.data.quantity
    });

    var gaEvent = {
      event: "add_to_cart",
      ecommerce: {
        currency: siteInfo.currencyCode,
        value: salesUnitPrice.priceExVat * event.data.quantity,
        items: ga4items
      }
    };

    return gaEvent;
  }

  RemoveFromCartEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) throw new Error('Product identifier missing');

    var product = EasyfyEventData.Product(event.data.productIdentifier);
    var salesUnitPrice = EasyfyEventData.ProductSalesUnitPrice(event.data.productIdentifier + "-" + event.data.salesUnitCode);
    var siteInfo = EasyfyEventData.SiteInfo();
    var ga4items: any[] = [];

    ga4items.push({
      discount: null,
      variant: null,
      coupon: null,
      price: salesUnitPrice.priceExVat,
      index: null,
      item_list_name: event.data.listName,
      item_variant: null,
      item_id: product.Id,
      item_name: product.DisplayName,
      item_brand: product.Brand,
      item_category: product.Categories.length > 0 ? product.Categories[0] : null,
      item_category2: product.Categories.length > 1 ? product.Categories[1] : null,
      item_category3: product.Categories.length > 2 ? product.Categories[2] : null,
      item_category4: product.Categories.length > 3 ? product.Categories[3] : null,
      item_category5: product.Categories.length > 4 ? product.Categories[4] : null,
      quantity: event.data.quantity
    });

    var gaEvent = {
      event: "remove_from_cart",
      ecommerce: {
        currency: siteInfo.currencyCode,
        value: salesUnitPrice.priceExVat * event.data.quantity,
        items: ga4items
      }
    };

    return gaEvent;
  }

  StartedCheckoutEvent(event: IEasyfyEvent): any {
    if (!event.data.checkoutProducts || event.data.checkoutProducts.length == 0) throw new Error('No products found');
    var ga4items: any[] = [];
    var siteInfo = EasyfyEventData.SiteInfo();
    var value: number = 0;

    event.data.checkoutProducts.forEach((checkoutProduct) => {
      var product = EasyfyEventData.Product(checkoutProduct.productIdentifier);
      var salesUnitPrice = EasyfyEventData.ProductSalesUnitPrice(checkoutProduct.productIdentifier + "-" + checkoutProduct.salesUnitCode);

      ga4items.push({
        discount: null,
        variant: null,
        coupon: null,
        price: salesUnitPrice.priceExVat,
        index: null,
        item_list_name: event.data.listName,
        item_variant: null,
        item_id: product.Id,
        item_name: product.DisplayName,
        item_brand: product.Brand,
        item_category: product.Categories.length > 0 ? product.Categories[0] : null,
        item_category2: product.Categories.length > 1 ? product.Categories[1] : null,
        item_category3: product.Categories.length > 2 ? product.Categories[2] : null,
        item_category4: product.Categories.length > 3 ? product.Categories[3] : null,
        item_category5: product.Categories.length > 4 ? product.Categories[4] : null,
        quantity: checkoutProduct.qty
      });

      value += salesUnitPrice.priceExVat * checkoutProduct.qty;
    });

    var gaEvent = {
      event: "begin_checkout",
      ecommerce: {
        currency: siteInfo.currencyCode,
        value: value,
        items: ga4items
      }
    };

    return gaEvent;
  }

  CompletedCheckoutEvent(event: IEasyfyEvent): any {
    if (!event.data.checkoutCompletedProducts || event.data.checkoutCompletedProducts.length == 0) throw new Error('No products found');
    var ga4items: any[] = [];
    var siteInfo = EasyfyEventData.SiteInfo();

    event.data.checkoutCompletedProducts.forEach((checkoutProduct) => {
      var product = EasyfyEventData.Product(checkoutProduct.productIdentifier);
      var salesUnitPrice = EasyfyEventData.ProductSalesUnitPrice(checkoutProduct.productIdentifier + "-" + checkoutProduct.salesUnitCode);

      ga4items.push({
        discount: null,
        variant: null,
        coupon: null,
        price: salesUnitPrice.priceExVat,
        index: null,
        item_list_name: event.data.listName,
        item_variant: null,
        item_id: product.Id,
        item_name: product.DisplayName,
        item_brand: product.Brand,
        item_category: product.Categories.length > 0 ? product.Categories[0] : null,
        item_category2: product.Categories.length > 1 ? product.Categories[1] : null,
        item_category3: product.Categories.length > 2 ? product.Categories[2] : null,
        item_category4: product.Categories.length > 3 ? product.Categories[3] : null,
        item_category5: product.Categories.length > 4 ? product.Categories[4] : null,
        quantity: checkoutProduct.qty
      });
    });

    var gaEvent = {
      event: "purchase",
      ecommerce: {
        transaction_id: event.data.completedCheckoutId,
        value: event.data.totalPriceExVat,
        tax: event.data.tax,
        shipping: event.data.shipping,
        currency: siteInfo.currencyCode,
        items: ga4items
      }
    };

    return gaEvent;
  }

  ContinueToPaymentEvent(event: IEasyfyEvent): any {
    if (!event.data.checkoutProducts || event.data.checkoutProducts.length == 0) {
      throw new Error('No products found');;
    }
    var ga4items: any[] = [];
    var siteInfo = EasyfyEventData.SiteInfo();
    var value: number = 0;

    event.data.checkoutProducts.forEach((checkoutProduct) => {
      var product = EasyfyEventData.Product(checkoutProduct.productIdentifier);
      var salesUnitPrice = EasyfyEventData.ProductSalesUnitPrice(checkoutProduct.productIdentifier + "-" + checkoutProduct.salesUnitCode);

      ga4items.push({
        discount: null,
        variant: null,
        coupon: null,
        price: salesUnitPrice.priceExVat,
        index: null,
        item_list_name: null,
        item_variant: null,
        item_id: product.Id,
        item_name: product.DisplayName,
        item_brand: product.Brand,
        item_category: product.Categories.length > 0 ? product.Categories[0] : null,
        item_category2: product.Categories.length > 1 ? product.Categories[1] : null,
        item_category3: product.Categories.length > 2 ? product.Categories[2] : null,
        item_category4: product.Categories.length > 3 ? product.Categories[3] : null,
        item_category5: product.Categories.length > 4 ? product.Categories[4] : null,
        quantity: checkoutProduct.qty,
        cd_campaign_code: product.CampaignCode,
      });

      value += salesUnitPrice.priceExVat * checkoutProduct.qty;

    });

    var gaEvent = {
      event: "continue_to_payment",
      ecommerce: {
        currency: siteInfo.currencyCode,
      }
    };

    return gaEvent;
  }
}